var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mail-list coming-soon"},[_c(_setup.PageHeader,{attrs:{"title":"通讯录"}}),_c('div',{staticClass:"options"},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("导出")])],1),_c('ming-table',{attrs:{"fields":_setup.column,"data":_setup.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }